var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('router-view',{attrs:{"name":"topbar"}}),_c('router-view',{attrs:{"name":"sidebar"}}),_c('v-main',{staticClass:"mt-5 mx-0 mx-md-4"},[_c('v-container',[_c('transition',{attrs:{"name":"fade-transform","mode":"out-in"}},[_c('router-view',{attrs:{"name":"main"}})],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }